<!-- Register.vue -->
<template>
  <div class="register-container">
    <!-- 搜索表单 -->
    <div class="search-card card">
      <form class="search-form">
        <div class="form-row">
          <div class="form-group">
            <label for="name">姓名</label>
            <input
                id="name"
                v-model="searchForm.name"
                type="text"
                placeholder="请输入姓名"
                class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="phone">手机号</label>
            <input
                id="phone"
                v-model="searchForm.phone"
                type="text"
                placeholder="请输入手机号"
                class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="sex">性别</label>
            <select
                id="sex"
                v-model="searchForm.sex"
                class="form-control"
            >
              <option value="">请选择性别</option>
              <option
                  v-for="item in sexOptions"
                  :key="item.value"
                  :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="registrationType">报名类型</label>
            <select
                id="registrationType"
                v-model="searchForm.registrationType"
                class="form-control"
            >
              <option value="">请选择报名类型</option>
              <option
                  v-for="item in registrationTypeOptions"
                  :key="item.value"
                  :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-actions">
          <button
              type="button"
              class="btn btn-primary"
              @click="handleSearch"
          >
            搜索
          </button>
          <button
              type="button"
              class="btn btn-default"
              @click="resetSearch"
          >
            重置
          </button>
        </div>
      </form>
    </div>

    <!-- 表格 -->
    <div class="table-card card">
      <div
          v-if="loading"
          class="loading-mask"
      >
        加载中...
      </div>
      <table class="data-table">
        <thead>
        <tr>
          <th>ID</th>
          <th>姓名</th>
          <th>手机号</th>
          <th>性别</th>
          <th>年龄</th>
          <th>机构名</th>
          <th>报名类型</th>
          <th>创建时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="item in tableData"
            :key="item.id"
        >
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.sex === 1 ? '男' : '女' }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.institutionName }}</td>
          <td>
            <span v-if="item.registrationType === 1">选手报名</span>
            <span v-else-if="item.registrationType === 2">机构报名</span>
            <span v-else-if="item.registrationType === 3">合作报名</span>
          </td>
          <td>{{ item.createTime }}</td>
          <td>
            <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="handleDelete(item.id)"
            >
              删除
            </button>
          </td>
        </tr>
        <tr v-if="tableData.length === 0 && !loading">
          <td
              colspan="9"
              class="empty-cell"
          >
            暂无数据
          </td>
        </tr>
        </tbody>
      </table>

      <!-- 分页 -->
      <div class="pagination-container">
        <div class="pagination-info">
          共 {{ pagination.rowCount }} 条记录
        </div>
        <div class="pagination-controls">
          <button
              class="btn btn-default"
              :disabled="pagination.pageNum === 1"
              @click="handlePageChange(pagination.pageNum - 1)"
          >
            上一页
          </button>
          <span class="page-info">
            第 {{ pagination.pageNum }} 页 / 共 {{ Math.ceil(pagination.rowCount / pagination.pageSize) }} 页
          </span>
          <button
              class="btn btn-default"
              :disabled="pagination.pageNum >= Math.ceil(pagination.rowCount / pagination.pageSize)"
              @click="handlePageChange(pagination.pageNum + 1)"
          >
            下一页
          </button>
          <select
              v-model="pagination.pageSize"
              class="page-size-select"
              @change="handleSizeChange"
          >
            <option
                v-for="size in [10, 20, 50, 100]"
                :key="size"
                :value="size"
            >
              每页 {{ size }} 条
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { getRegisterList, deleteRegister } from '@/api/website'

// 分页数据
const pagination = reactive({
  pageNum: 1,
  pageSize: 10,
  rowCount: 0
})

// 搜索表单数据
const searchForm = reactive({
  name: '',
  phone: '',
  sex: '',
  registrationType: ''
})

// 表格数据
const tableData = ref([])
const loading = ref(false)

// 性别选项
const sexOptions = [
  { label: '男', value: 1 },
  { label: '女', value: 2 }
]

// 报名类型选项
const registrationTypeOptions = [
  { label: '选手报名', value: 1 },
  { label: '机构报名', value: 2 },
  { label: '合作报名', value: 3 }
]

// 获取列表数据
const fetchRegisterList = async () => {
  loading.value = true
  try {
    const params = {
      pageNum: pagination.pageNum,
      pageSize: pagination.pageSize,
      ...searchForm
    }
   console.log('获取报名列表参数:', params)
    const response = await getRegisterList(params)
    console.log('获取报名列表成功:', response.data.data)
    if (response.data.code === 200){
      tableData.value = response.data.data.list
      pagination.rowCount = response.data.data.rowCount
    }

  } catch (error) {
    console.error('获取报名列表失败:', error)
    tableData.value = []
    pagination.rowCount = 0
  } finally {
    loading.value = false
  }
}

// 搜索
const handleSearch = () => {
  pagination.pageNum = 1
  fetchRegisterList()
}

// 重置搜索
const resetSearch = () => {
  searchForm.name = ''
  searchForm.phone = ''
  searchForm.sex = ''
  searchForm.registrationType = ''
  pagination.pageNum = 1
  fetchRegisterList()
}

// 分页变化
const handlePageChange = (page) => {
  pagination.pageNum = page
  fetchRegisterList()
}

// 每页条数变化
const handleSizeChange = () => {
  pagination.pageNum = 1
  fetchRegisterList()
}

// 删除报名记录
const handleDelete = async (id) => {
  if (!confirm('确定要删除这条记录吗？')) {
    return
  }
  try {
    await deleteRegister(id)
    fetchRegisterList()
  } catch (error) {
    console.error('删除失败:', error)
  }
}

// 初始化加载
onMounted(() => {
  fetchRegisterList()
})
</script>

<style scoped lang="scss">
.register-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    padding: 20px;
  }

  .search-card {
    .search-form {
      .form-row {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-bottom: 20px;

        .form-group {
          flex: 1;
          min-width: 200px;

          label {
            display: block;
            margin-bottom: 5px;
            font-weight: 500;
            color: #333;
          }

          .form-control {
            width: 80%;
            padding: 8px 12px;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            font-size: 14px;
            transition: border-color 0.3s;

            &:focus {
              outline: none;
              border-color: #409eff;
            }
          }
        }
      }

      .form-actions {
        text-align: right;

        .btn {
          margin-left: 10px;
          padding: 8px 16px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          transition: background-color 0.3s;

          &.btn-primary {
            background-color: #409eff;
            color: white;

            &:hover {
              background-color: #66b1ff;
            }
          }

          &.btn-default {
            background-color: #ffffff;
            color: #606266;
            border: 1px solid #dcdfe6;

            &:hover {
              background-color: #f5f7fa;
            }
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  .table-card {
    position: relative;

    .loading-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 60px;
      background: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      font-size: 16px;
      color: #606266;
    }

    .data-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;

      th,
      td {
        padding: 12px 10px;
        text-align: left;
        border-bottom: 1px solid #ebeef5;
      }

      th {
        background-color: #f5f7fa;
        font-weight: 500;
        color: #606266;
      }

      tbody {
        tr {
          &:hover {
            background-color: #f5f7fa;
          }

          td {
            color: #606266;

            .btn {
              padding: 4px 8px;
              border: none;
              border-radius: 3px;
              cursor: pointer;
              font-size: 12px;
              transition: background-color 0.3s;

              &.btn-danger {
                background-color: #f56c6c;
                color: white;

                &:hover {
                  background-color: #f78989;
                }
              }

              &.btn-sm {
                padding: 3px 6px;
                font-size: 12px;
              }
            }
          }
        }

        .empty-cell {
          text-align: center;
          color: #909399;
          font-style: italic;
        }
      }
    }

    .pagination-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #ebeef5;

      .pagination-info {
        color: #606266;
        font-size: 14px;
      }

      .pagination-controls {
        display: flex;
        align-items: center;
        gap: 10px;

        .btn {
          padding: 6px 12px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          background: #fff;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s;

          &:hover:not(:disabled) {
            background-color: #f5f7fa;
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }

        .page-info {
          color: #606266;
          font-size: 14px;
          margin: 0 10px;
        }

        .page-size-select {
          padding: 6px 10px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          background: #fff;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
